<template>
  <div id='map' :style='{height: mapHeight+"px"}'></div>
</template>

<script>
import $ from 'jquery'
import { http } from '@/http'
import layer from '@/utils/layer'
import { baiduMapLayer, utilCurve, DataSet } from 'mapv'
import echarts from 'echarts'
import 'echarts/chart/map'
import BMapExt from '@/utils/BMap/main'
import mapMethod from '@/utils/BMap/methods'
import { mayStyle, timeOptions, circleOptions, cityNameOptions, top10boundaryOptions, top30boundaryOptions } from '@/utils/BMap/styles'

const BMap = window.BMap
const homeTimer = 100

const viewportMargin = {
  margins: [50, 50, 50, 50]
}

export default{
  props: ['list', 'summary'],
  data () {
    return {
      homeDstLayer: [],
      homeAnimationLayer: [],
      homeCircleLayer: [],
      mapHeight: window.innerHeight - 50
    }
  },
  watch: {
    list (n, o) {
      this.mapData = n
      if (typeof this[this.$route.name] === 'function') {
        this.destroyAll()
        this[this.$route.name]()
      }
    }
  },
  mounted () {
    this.bMapExt = new BMapExt($('#map')[0], window.BMap, echarts, {
      enableMapClick: false,
      minZoom: 5,
      maxZoom: 10
    })
    this.map = this.bMapExt.getMap()
    // 获取echarts的dom容器
    this.container = this.bMapExt.getEchartsContainer()
    // 通过initEcharts初始化echarts并获取实例
    this.myChart = this.bMapExt.initECharts(this.container)
    window.onresize = this.myChart.resize

    this.bMapExt.setOption({
      series: [{
        type: 'map',
        mapType: 'none',
        data: []
      }]
    }, true)

    // centerAndZoom会触发页面刷新,页面刷新需要echarts的option
    this.map.centerAndZoom(new BMap.Point(105.403119, 38.028658), 5) // 初始化地图，设置中心点坐标和地图级别
    this.map.enableScrollWheelZoom(true) // 开启鼠标滚轮缩放
    const ctrl = new BMap.ZoomControl({
      anchor: window.BMAP_ANCHOR_TOP_RIGHT
    })
    this.map.addControl(ctrl)

    this.map.setMapStyleV2(mayStyle)
    window.onresize = (e) => {
      this.myChart.resize(e)
      this.mapHeight = window.innerHeight - 50
    }
  },
  beforeDestroy () {
    this.destroyAll()
  },
  methods: {
    destroyAll () {
      // 页面销毁时清楚定时器
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = undefined
      }
      if (this.clearTimer) {
        clearInterval(this.clearTimer)
        this.clearTimer = undefined
      }
      layer.destroyAll()
    },
    home () {
      this.homeNext = 0
      this.clearTimer = setInterval(() => {
        this.bMapExt.refresh()
      }, 60000)
      setTimeout(() => {
        // 一小时，刷新一次页面
        location.reload()
      }, 60 * 60 * 1000)
      this.timer = setInterval(() => {
        this.homeFlow()
      }, homeTimer)
      if (this.$route.query.province_id) {
        this.hightMapList([this.$route.query.province_id], [top10boundaryOptions])
        this.myChart.dom.parentNode.style.zIndex = parseInt(this.myChart.dom.parentNode.style.zIndex) * 2
      }
    },
    countyList () {
      layer.destroyAll()
      this.countyFlow()
    },
    countyFlow () {
      const data = this.mapData
      const img = new Image()
      img.src = '/img/oval.png'
      const iconCityOptions = {
        width: 28,
        height: 28,
        zIndex: 1,
        draw: 'icon'
      }
      const circleData = []
      const cityName = []
      const iconData = []
      const points = []
      data.forEach(value => {
        points.push(new BMap.Point(value.src_lon, value.src_lat))
        points.push(new BMap.Point(value.dst_lon, value.dst_lat))
      })
      this.map.setViewport(points, viewportMargin)
      const zoom = this.map.getZoom()
      let srcItem
      const locationIds = []
      const optionList = []
      data.forEach((value, key) => {
        locationIds.push(value.dst_loc_id)
        if (key === 0) {
          srcItem = value
        }
        if (key < 10) {
          const timeData = []
          const distance = (this.map.getDistance(
            new BMap.Point(value.src_lon, value.src_lat),
            new BMap.Point(value.dst_lon, value.dst_lat)
          ) || 0) / 1000
          const steps = parseInt((distance + 50) * zoom / (15 * 5)) // 当zoom为5时，100千米起，每15千米多一个点
          const curve = utilCurve.getPoints([{
            lng: value.src_lon,
            lat: value.src_lat
          }, {
            lng: value.dst_lon,
            lat: value.dst_lat
          }], { count: steps })
          for (let i = 0; i < curve.length; i++) {
            timeData.push({
              geometry: {
                type: 'Point',
                coordinates: curve[i]
              },
              time: i
            })
          }
          const newTimeOptions = JSON.parse(JSON.stringify(timeOptions))
          newTimeOptions.animation.stepsRange.end = steps
          const duration = (steps + 80) / 80
          newTimeOptions.animation.trails = parseInt((steps * 10 + 100) / 100) || 1
          newTimeOptions.animation.duration = duration
          // eslint-disable-next-line
          layer.add(new baiduMapLayer(this.map, new DataSet(timeData), newTimeOptions))
          iconData.push({
            geometry: {
              type: 'Point',
              coordinates: [value.dst_lon, value.dst_lat]
            },
            icon: img
          })
          optionList.push(top10boundaryOptions)
        } else {
          circleData.push({
            geometry: {
              type: 'Point',
              coordinates: [value.dst_lon, value.dst_lat]
            },
            count: 15
          })
          optionList.push(top30boundaryOptions)
        }
        cityName.push({
          geometry: {
            type: 'Point',
            coordinates: [value.dst_lon, value.dst_lat]
          },
          text: value.dst_name.join('')
        })
      })
      if (srcItem && srcItem.src_loc_id) locationIds.push(srcItem.src_loc_id)
      optionList.push(top10boundaryOptions)
      this.hightMapList(locationIds, optionList)
      if (srcItem) {
        circleData.push({
          geometry: {
            type: 'Point',
            coordinates: [srcItem.src_lon, srcItem.src_lat]
          },
          count: 15
        })
        cityName.push({
          geometry: {
            type: 'Point',
            coordinates: [srcItem.src_lon, srcItem.src_lat]
          },
          text: srcItem.src_name.join('')
        })
      }
      /* eslint-disable */
      layer.add(new baiduMapLayer(this.map, new DataSet(circleData), circleOptions))
      layer.add(new baiduMapLayer(this.map, new DataSet(iconData), iconCityOptions))
      layer.add(new baiduMapLayer(this.map, new DataSet(cityName), cityNameOptions))
      /* eslint-enable */
    },
    homeFlow () {
      const position = this.homeNext
      const data = this.mapData
      this.keyMap = this.keyMap || {}
      const srcTitle = `${data[position].src_lon},${data[position].src_lat},${position}`
      const dstTitle = `${data[position].dst_lon},${data[position].dst_lat},${position}`

      const option = {}
      if (this.keyMap[srcTitle]) {
        this.keyMap[srcTitle]++
      } else {
        this.keyMap[srcTitle] = 1
        option[srcTitle] = [data[position].src_lon, data[position].src_lat]
      }
      if (this.keyMap[dstTitle]) {
        this.keyMap[dstTitle]++
      } else {
        this.keyMap[dstTitle] = 1
        option[dstTitle] = [data[position].dst_lon, data[position].dst_lat]
      }
      this.bMapExt.setGeoCoord(option)
      this.myChart.addMarkLine(0, mapMethod.echartsAddMarkLine(srcTitle, dstTitle, '#faff00'))
      setTimeout(() => {
        this.myChart.addMarkPoint(0, mapMethod.echartsAddMarkPoint(dstTitle, '#faff00'))
        this.myChart.delMarkLine(0, srcTitle + ' > ' + dstTitle)
        setTimeout(() => {
          this.myChart.delMarkPoint(0, dstTitle)
          const temp = {}
          this.keyMap[srcTitle]--
          this.keyMap[dstTitle]--
          if (this.keyMap[srcTitle] < 1) {
            temp[srcTitle] = ''
            delete this.keyMap[srcTitle]
          }
          if (this.keyMap[dstTitle] < 1) {
            temp[dstTitle] = ''
            delete this.keyMap[dstTitle]
          }
          this.bMapExt.delGeoCoord(temp)
        }, 1000)
      }, 2000)

      let next = position + 1
      if (next >= data.length) {
        next = 0
      }
      this.homeNext = next
    },
    nationDetail () {
      // 全国详情
      const img = new Image()
      img.src = '//img.yimutian.com/crm/5bcc2f8764008157d949704f4e33fc62.png'
      const iconCityOptions = {
        width: 20,
        height: 28,
        zIndex: 1,
        draw: 'icon'
      }
      const rankOptions = {
        font: '10px Arial',
        fillStyle: '#fff',
        zIndex: 2,
        offset: {
          x: 0,
          y: -4
        },
        draw: 'text'
      }
      const cityOptions = {
        font: '10px Arial',
        fillStyle: '#fff',
        zIndex: 3,
        offset: {
          x: 0,
          y: 24
        },
        draw: 'text'
      }
      img.onload = () => {
        const iconData = [] // 前10名图标数据
        const rankData = [] // 前10名图标上排名文字数据
        const cityData = [] // 城市名数据
        const circleData = [] // 前10名以后数据
        const points = []
        const locationIds = []
        const optionList = []
        this.mapData.forEach(value => {
          locationIds.push(value.loc_id)
          points.push(new BMap.Point(value.lon, value.lat))
          if (value.rank < 11) {
            iconData.push({
              geometry: {
                type: 'Point',
                coordinates: [value.lon, value.lat]
              },
              icon: img
            })
            rankData.push({
              geometry: {
                type: 'Point',
                coordinates: [value.lon, value.lat]
              },
              text: value.rank
            })
            cityData.push({
              geometry: {
                type: 'Point',
                coordinates: [value.lon, value.lat]
              },
              text: value.location
            })
            optionList.push(top10boundaryOptions)
          } else {
            optionList.push(top30boundaryOptions)
            circleData.push({
              geometry: {
                type: 'Point',
                coordinates: [value.lon, value.lat]
              },
              // count: value.rank
              count: 20
            })
          }
        })
        this.hightMapList(locationIds, optionList)
        this.map.setViewport(points, viewportMargin)
        /* eslint-disable */
        layer.add(new baiduMapLayer(this.map, new DataSet(iconData), iconCityOptions))
        layer.add(new baiduMapLayer(this.map, new DataSet(rankData), rankOptions))
        layer.add(new baiduMapLayer(this.map, new DataSet(cityData), cityOptions))
        layer.add(new baiduMapLayer(this.map, new DataSet(circleData), circleOptions))
        /* eslint-enable */
      }
    },
    countyDetail () {
      if (this.$route.query.type === 'seller') {
        this.nationDetail()
      } else {
        const img = new Image()
        img.src = '/img/oval.png'
        const iconCityOptions = {
          width: 28,
          height: 28,
          zIndex: 1,
          draw: 'icon'
        }
        const cityName = []
        const circleData = []
        const iconData = []
        circleData.push({
          geometry: {
            type: 'Point',
            coordinates: [this.summary.lon, this.summary.lat]
          },
          count: 15
        })
        cityName.push({
          geometry: {
            type: 'Point',
            coordinates: [this.summary.lon, this.summary.lat]
          },
          text: this.summary.location_name.join('')
        })
        const points = [new BMap.Point(this.summary.lon, this.summary.lat)]
        this.mapData.forEach(value => {
          points.push(new BMap.Point(value.lon, value.lat))
        })
        this.map.setViewport(points, viewportMargin)
        const locationIds = []
        const optionList = []
        this.mapData.forEach((value, index) => {
          locationIds.push(value.loc_id)
          if (value.rank < 11) {
            let curveParam = []
            if (this.$route.query.type === 'seller') {
              curveParam = [{
                lng: value.lon,
                lat: value.lat
              }, {
                lng: this.summary.lon,
                lat: this.summary.lat
              }]
            } else {
              curveParam = [{
                lng: this.summary.lon,
                lat: this.summary.lat
              }, {
                lng: value.lon,
                lat: value.lat
              }]
            }
            const timeData = []
            const distance = (this.map.getDistance(
              new BMap.Point(this.summary.lon, this.summary.lat),
              new BMap.Point(value.lon, value.lat)
            ) || 0) / 1000
            const steps = parseInt((distance + 50) / 15) // 100千米起，每6千米多一个点
            const curve = utilCurve.getPoints(curveParam, { count: steps })
            for (let i = 0; i < curve.length; i++) {
              timeData.push({
                geometry: {
                  type: 'Point',
                  coordinates: curve[i]
                },
                time: i
              })
            }
            const newTimeOptions = JSON.parse(JSON.stringify(timeOptions))
            newTimeOptions.animation.stepsRange.end = steps
            const duration = (steps + 80) / 80
            newTimeOptions.animation.trails = parseInt((steps * 10 + 100) / 100) || 1
            newTimeOptions.animation.duration = duration
            // eslint-disable-next-line
            layer.add(new baiduMapLayer(this.map, new DataSet(timeData), newTimeOptions))

            iconData.push({
              geometry: {
                type: 'Point',
                coordinates: [value.lon, value.lat]
              },
              icon: img
            })
            optionList.push(top10boundaryOptions)
          } else {
            circleData.push({
              geometry: {
                type: 'Point',
                coordinates: [value.lon, value.lat]
              },
              count: 15
            })
            optionList.push(top30boundaryOptions)
          }
          cityName.push({
            geometry: {
              type: 'Point',
              coordinates: [value.lon, value.lat]
            },
            text: value.location.join('')
          })
        })
        this.hightMapList(locationIds, optionList)
        /* eslint-disable */
        layer.add(new baiduMapLayer(this.map, new DataSet(cityName), cityNameOptions))
        layer.add(new baiduMapLayer(this.map, new DataSet(circleData), circleOptions))
        layer.add(new baiduMapLayer(this.map, new DataSet(iconData), iconCityOptions))
        /* eslint-enable */
      }
    },
    hightMapList (list, optionList) {
      http.get('/canmou/tianji/boundary', {
        params: {
          loc: list.join(',')
        }
      }).then(res => {
        const data = res.data
        if (data.status === 0) {
          for (let i in list) {
            const boundaryData = []
            const boundaries = data.data[list[i]]
            if (!boundaries) break
            let type = 'Polygon'
            const temp = []
            if (boundaries.length > 0) {
              if (boundaries.length > 1) {
                type = 'MultiPolygon'
              }
              boundaries.forEach((val1, index) => {
                temp.push([])
                val1.split(';').forEach(val2 => {
                  temp[temp.length - 1].push(val2.split(','))
                })
              })
              boundaryData.push({
                geometry: {
                  type: type,
                  coordinates: type === 'Polygon' ? [...temp] : [temp]
                }
              })
              // eslint-disable-next-line
              layer.add(new baiduMapLayer(this.map, new DataSet(boundaryData), optionList[i]))
              i++
            }
          }
        }
      })
    },
    // 高亮区域地图
    hightMap (name, option) {
      new BMap.Boundary().get(name, data => {
        const boundaryData = []
        const boundaries = data.boundaries
        let type = 'Polygon'
        const temp = []
        if (boundaries.length > 0) {
          if (boundaries.length > 1) {
            type = 'MultiPolygon'
          }
          boundaries.forEach((val1, index) => {
            temp.push([])
            val1.split(';').forEach(val2 => {
              temp[temp.length - 1].push(val2.split(','))
            })
          })
          boundaryData.push({
            geometry: {
              type: type,
              coordinates: type === 'Polygon' ? [...temp] : [temp]
            }
          })
          // eslint-disable-next-line
          layer.add(new baiduMapLayer(this.map, new DataSet(boundaryData), option))
        }
      })
    }
  },
  components: {
  }
}
</script>
<style lang='less'>
  #map{
    width: 100%;
  }
</style>
